import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../redux/store';
import AppleLogo from '../assets/svg/apple.svg';
import GoogleLogo from '../assets/svg/google.svg';
import { fetchSocialLinks } from '../redux/socialSlice'; // ⬅️ Import this
import StripeImage from "../assets/meta/stripe.png";
import {
  Copyright,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
} from "lucide-react";
import { CsmSwitcher } from '@cosmoola/react-cosmoola-js';

const currentYear = new Date().getFullYear();

const Footer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { social } = useSelector((state: RootState) => state.social);

  useEffect(() => {
    dispatch(fetchSocialLinks());
  }, [dispatch]);
  
  const buildSocialLink = (platform: string, handle?: string) => {
    if (!handle) return `https://${platform}.com`;
    if (handle.startsWith('http')) return handle;
    if (platform === 'youtube') return `https://www.youtube.com/@${handle}`;
    return `https://${platform}.com/${handle}`;
  };
  
  const socialIcons = [
{
  icon: <Facebook size={20} />,
  href: buildSocialLink("facebook", social?.facebook),
},
{
  icon: <Instagram size={20} />,
  href: buildSocialLink("instagram", social?.instagram),
},
{
  icon: <Twitter size={20} />,
  href: buildSocialLink("twitter", social?.twitter),
},
{
  icon: <Youtube size={20} />,
  href: buildSocialLink("youtube", social?.youtube),
},
  ];
  



 {/* const sections = [
    {
      title: 'Support',
      links: [
        ['Help Center', 'https://areluxe.com/pages/helpsupport'],
        ['AirCover', 'https://areluxe.com/pages/aircover'],
         ['Anti‑discrimination', 'https://areluxe.com/pages/anti-discrimination'],
         ['Disability support', 'https://areluxe.com/pages/disability-support'],
         ['Cancellation options', 'https://areluxe.com/pages/cancellation'],
         ['Report neighborhood concern', 'https://areluxe.com/pages/report-neighborhood'], 
      ],
    },

    // Commenting out Hosting section
    
    {
      title: 'Hosting',
      links: [
        ['Host with Areluxe', 'https://areluxe.com/pages/host'],
        ['Host Protection', 'https://areluxe.com/pages/aircover-for-hosts'],
        ['Resources', 'https://areluxe.com/pages/resources'],
        ['Community forum', 'https://areluxe.com/pages/community'],
        ['Responsible Hosting', 'https://areluxe.com/pages/responsible-hosting'],
        ['Host‑ready apartments', 'https://areluxe.com/pages/airbnb-apartments'],
        ['Free hosting classes', 'https://areluxe.com/pages/free-class'],
        ['Find a co‑host', 'https://areluxe.com/pages/find-cohost'],
      ],
    }, 


    

    // Commenting out Areluxe section
    

    {
      title: 'Areluxe',
      links: [
        ['2025 Summer Release', 'https://areluxe.com/pages/summer-release'],
        ['Newsroom', 'https://areluxe.com/pages/newsroom'],
        ['New features', 'https://areluxe.com/pages/features'],
        ['Careers', 'https://areluxe.com/pages/careers'],
        ['Investors', 'https://areluxe.com/pages/investors'],
        ['Gift cards', 'https://areluxe.com/pages/gift-cards'],
        ['Areluxe.org relief stays', 'https://areluxe.com/pages/areluxe-org'],
      ],
    },
    
  ]; */}

  return (
    <footer style={styles.footer}>
      {/* Gradient hover style */}
      <style>
        {`
          .hover-gradient {
            color: #000;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .hover-gradient:hover {
            background: linear-gradient(to right, gold, black);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
        `}
      </style>

      {/* Divider */}
      <div style={styles.divider}></div>

     {/* Grid Links 
      <div style={styles.grid}>
        {sections.map((section) => (
          <div key={section.title} style={styles.column}>
            <h4 style={styles.heading}>{section.title}</h4>
            {section.links.map(([label, href]) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="hover-gradient">
                {label}
              </a>
            ))}
          </div>
        ))}
      </div> */}

      {/* CosMeta App row   */}
            <div style={styles.appRow}>

        <img
  src={StripeImage}
  alt="Secure payments powered by Stripe"
  style={styles.stripeImage}
/>

    {/*
    
        <h4 style={styles.appTitle}>DOWNLOAD THE COSMETA APP</h4>
        <div style={styles.appLinks}>
          <a href="https://play.google.com/store/apps/details?id=com.armerix.android" target="_blank" rel="noopener noreferrer">
            <img src={GoogleLogo} alt="Google Play" style={styles.storeIcon} />
          </a>
          <a href="https://apps.apple.com/app/idYOUR_APP_ID" target="_blank" rel="noopener noreferrer">
            <img src={AppleLogo} alt="Apple Store" style={styles.storeIcon} />
          </a>
        </div>
    
    */}
      </div>
      
    


      {/* Social and bottom row */}
      <div>
        <h4 style={styles.connectTitle}>Connect with us</h4>
        <p style={styles.shareText}>Share your COSMETA experience</p>

        <div style={styles.socials}>
          {socialIcons.map(({ icon, href }, i) => (
            <a key={i} href={href} target="_blank" rel="noopener noreferrer" style={styles.socialSquare}>
              {icon}
            </a>
          ))}
        </div>
      </div>



<div style={styles.ownershipText}>
  <a href="/" style={styles.brandGradient3D}>
    COSMETA
  </a>{" "}
  is a subsidiary of{" "}
  <a
    href="https://saloisa.com"
    target="_blank"
    rel="noopener noreferrer"
    style={styles.brandGradient3D}
  >
    Saloisa Group OÜ
  </a>
  , an Estonia-registered company operating under EU regulations.
</div>



      <div style={styles.bottomRow}>
        <div style={styles.left}>
          <Copyright size={14} />
          <span>{currentYear} COSMETA, Inc.</span>
          <span style={styles.dot}>·</span>
          <a href="https://cosmeta.store/pages/about-us" className="hover-gradient">About Us</a>
           <a href="https://cosmeta.store/pages/terms" className="hover-gradient">Terms</a>
           <a href="https://cosmeta.store/pages/privacy-settings" className="hover-gradient">Privacy</a>
           <a href="https://cosmeta.store/pages/your-privacy-choices" className="hover-gradient">Your Privacy Choices</a>
          <a href="https://cosmeta.store/news" className="hover-gradient">News</a>
        </div>

      {/* <div style={styles.right}>
          <div style={styles.dropdown}><Globe size={16} /><select style={styles.select}><option>English (US)</option></select></div>
          <div style={styles.dropdown}>
            <CurrencyEur size={16} />
            <select
              value={currency}
              onChange={(e) => dispatch(setCurrency(e.target.value as 'USD' | 'EUR' | 'KES'))}
              style={styles.select}
            >
              <option value="EUR">EUR</option>
              <option value="USD">USD</option>
              <option value="KES">KES</option>
            </select>
          </div>

        </div>*/}

           <div style={{
            position: "fixed",
            left: "80%",
            transform: "translateX(-50%)",
            zIndex: 99999,
          }}>
            <CsmSwitcher />
          </div>
      </div>
    </footer>
  );
};

export default Footer;


const styles: { [key: string]: React.CSSProperties } = {
  footer: {
    backgroundColor: "#ffffffff",
    padding: "40px 20px 20px",
    fontSize: 14,
    color: "#222",
    borderTop: "1px solid #ddd",
    display: "flex",
    flexDirection: "column",
    gap: 30,
  },

  divider: {
    height: 2,
    width: "100%",
    background: "linear-gradient(to right, #ccc, skyblue)",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 40,
  },

  column: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },

  heading: {
    fontWeight: "bold",
    fontSize: 15,
    marginBottom: 10,
    color: "#111",
  },

  /* =========================
     APP DOWNLOAD (CENTERED)
     ========================= */
  appRow: {
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    alignItems: "center",   // ✅ center content horizontally
    textAlign: "center",    // ✅ center text
  },

  appTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#111",
    textAlign: "center",
  },

  appLinks: {
    display: "flex",
    gap: 16,
    justifyContent: "center", // ✅ center icons row
    alignItems: "center",
  },

  storeIcon: {
    height: 40,
    objectFit: "contain",
  },

  /* =========================
     SOCIALS (CENTERED)
     ========================= */
  connectTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 6,
    color: "#111",
    textAlign: "center",   // ✅
  },

  shareText: {
    fontSize: 14,
    marginBottom: 6,
    color: "#333",
    textAlign: "center",   // ✅
  },

  socials: {
    display: "flex",
    gap: 12,
    marginTop: 10,
    flexWrap: "wrap",
    justifyContent: "center", // ✅ center icons
  },

  socialSquare: {
    width: 34,
    height: 34,
    background: 
      "linear-gradient(135deg, #00275fff 0%, #1a4fa3 50%, #FEBA02 100%)",
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },

  /* =========================
     OWNERSHIP / BRANDING
     ========================= */
  ownershipText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 600,
    marginTop: 16,
    color: "#222",
  },

  brandGradient3D: {
    fontWeight: 900,
    fontSize: 20,
    letterSpacing: 0.3,
    background:
      "linear-gradient(135deg, #00275fff 0%, #1a4fa3 50%, #FEBA02 100%)",

    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    cursor: "pointer",
    display: "inline-block",
    transition: "transform 0.15s ease, filter 0.15s ease",
    textDecoration: "none",
    filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.3))",
  },

  /* =========================
     BOTTOM ROW
     ========================= */
  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    borderTop: "1px solid #ddd",
    paddingTop: 20,
    fontSize: 13,
    gap: 16,
  },

  left: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
  },

  dot: {
    margin: "0 4px",
    color: "#999",
  },

  right: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 16,
  },

  dropdown: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },

  select: {
    border: "none",
    background: "transparent",
    fontSize: 13,
    cursor: "pointer",
    outline: "none",
  },

  stripeImage: {
  height: 90,
  marginBottom: 16,
  objectFit: "contain",
  opacity: 0.95,
  filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.15))",
},


};
